import(/* webpackMode: "eager" */ "/app/app/sin-performer/[slug]/page.js");
